// extracted by mini-css-extract-plugin
export var banner = "_e4-0";
export var closeButton = "_e4-2";
export var greenCheckmark = "_e4-3";
export var hereLink = "_e4-4";
export var titleIcon = "_e4-1";